import { Routes, Route, Navigate } from 'react-router-dom';

import { Setting } from '@modules/settings/pages/Setting';

import { NotFound } from '@shared/pages/NotFound';

export function SettingRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Setting />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<Navigate replace to="/not-found" />} />
    </Routes>
  );
}
